/**
 * Exibicao do nome de um Modelo (objetivo Modelo, tipoConteudo === 3).
 *
 * No cadastro (fluxo de criacao), o catalogo de produto/modelo devolve tanto
 * cod_modelo quanto descricao_modelo, entao o par completo aparece: "POP —
 * POP 110I+10". Ja no historico usado para reabrir uma meta salva (GET
 * /campanhas/metas-campanha, lido em ModalCadastroMeta.metaInfoMap), a view
 * so devolve a descricao (row.produto) — cod_modelo nunca existiu ali, entao
 * nao ha como inventa-lo.
 *
 * Este helper centraliza a regra usada nos tres lugares que renderizam esse
 * par (SubEtapaCalculoModelo, ModalCadastroSubEtapaObjetivo,
 * ModalCadastroSubEtapaResumoMeta): junta os dois quando ambos existem, cai
 * para so um dos dois quando falta o outro, e nunca deixa um travessao
 * sozinho quando os dois faltam.
 *
 * @param {string|number|null|undefined} cod       - cod_modelo (so existe no catalogo de criacao)
 * @param {string|null|undefined}        descricao - descricao_modelo (sempre disponivel, criacao e edicao)
 * @returns {string}
 */
export function formatarNomeModelo(cod, descricao) {
  const temCod = cod !== null && cod !== undefined && cod !== "";
  const temDescricao = descricao !== null && descricao !== undefined && descricao !== "";

  if (temCod && temDescricao) return `${cod} — ${descricao}`;
  if (temDescricao) return String(descricao);
  if (temCod) return String(cod);
  return "—";
}
